// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/agenttools/v1/catalog.proto (package mono.agenttools.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Struct } from "@bufbuild/protobuf";
/**
 * TokenCost is a coarse-grained hint to the LLM about how expensive a tool
 * invocation is in tokens (input + output). Used for ranking when the agent
 * has multiple ways to accomplish a task.
 *
 * @generated from enum mono.agenttools.v1.TokenCost
 */ export var TokenCost = /*#__PURE__*/ function(TokenCost) {
    /**
   * @generated from enum value: TOKEN_COST_UNSPECIFIED = 0;
   */ TokenCost[TokenCost["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: TOKEN_COST_LOW = 1;
   */ TokenCost[TokenCost["LOW"] = 1] = "LOW";
    /**
   * @generated from enum value: TOKEN_COST_MEDIUM = 2;
   */ TokenCost[TokenCost["MEDIUM"] = 2] = "MEDIUM";
    /**
   * @generated from enum value: TOKEN_COST_HIGH = 3;
   */ TokenCost[TokenCost["HIGH"] = 3] = "HIGH";
    return TokenCost;
}({});
// Retrieve enum metadata with: proto3.getEnumType(TokenCost)
proto3.util.setEnumType(TokenCost, "mono.agenttools.v1.TokenCost", [
    {
        no: 0,
        name: "TOKEN_COST_UNSPECIFIED"
    },
    {
        no: 1,
        name: "TOKEN_COST_LOW"
    },
    {
        no: 2,
        name: "TOKEN_COST_MEDIUM"
    },
    {
        no: 3,
        name: "TOKEN_COST_HIGH"
    }
]);
/**
 * ToolOrigin identifies which subsystem implements the tool. Pre-staged to
 * avoid proto churn as additional service-RPC waves are wrapped. Only
 * SHANKS_NATIVE is emitted in v1.0; later waves emit the others as they ship.
 *
 * @generated from enum mono.agenttools.v1.ToolOrigin
 */ export var ToolOrigin = /*#__PURE__*/ function(ToolOrigin) {
    /**
   * @generated from enum value: TOOL_ORIGIN_UNSPECIFIED = 0;
   */ ToolOrigin[ToolOrigin["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: TOOL_ORIGIN_SHANKS_NATIVE = 1;
   */ ToolOrigin[ToolOrigin["SHANKS_NATIVE"] = 1] = "SHANKS_NATIVE";
    /**
   * @generated from enum value: TOOL_ORIGIN_ICEBURG_RPC = 2;
   */ ToolOrigin[ToolOrigin["ICEBURG_RPC"] = 2] = "ICEBURG_RPC";
    /**
   * @generated from enum value: TOOL_ORIGIN_RYUGU_RPC = 3;
   */ ToolOrigin[ToolOrigin["RYUGU_RPC"] = 3] = "RYUGU_RPC";
    /**
   * @generated from enum value: TOOL_ORIGIN_ZOU_RPC = 4;
   */ ToolOrigin[ToolOrigin["ZOU_RPC"] = 4] = "ZOU_RPC";
    /**
   * @generated from enum value: TOOL_ORIGIN_MORGANS_RPC = 5;
   */ ToolOrigin[ToolOrigin["MORGANS_RPC"] = 5] = "MORGANS_RPC";
    /**
   * @generated from enum value: TOOL_ORIGIN_BALTIGO_RPC = 6;
   */ ToolOrigin[ToolOrigin["BALTIGO_RPC"] = 6] = "BALTIGO_RPC";
    /**
   * @generated from enum value: TOOL_ORIGIN_OHARA_RPC = 7;
   */ ToolOrigin[ToolOrigin["OHARA_RPC"] = 7] = "OHARA_RPC";
    /**
   * @generated from enum value: TOOL_ORIGIN_COMPOSITE = 8;
   */ ToolOrigin[ToolOrigin["COMPOSITE"] = 8] = "COMPOSITE";
    return ToolOrigin;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ToolOrigin)
proto3.util.setEnumType(ToolOrigin, "mono.agenttools.v1.ToolOrigin", [
    {
        no: 0,
        name: "TOOL_ORIGIN_UNSPECIFIED"
    },
    {
        no: 1,
        name: "TOOL_ORIGIN_SHANKS_NATIVE"
    },
    {
        no: 2,
        name: "TOOL_ORIGIN_ICEBURG_RPC"
    },
    {
        no: 3,
        name: "TOOL_ORIGIN_RYUGU_RPC"
    },
    {
        no: 4,
        name: "TOOL_ORIGIN_ZOU_RPC"
    },
    {
        no: 5,
        name: "TOOL_ORIGIN_MORGANS_RPC"
    },
    {
        no: 6,
        name: "TOOL_ORIGIN_BALTIGO_RPC"
    },
    {
        no: 7,
        name: "TOOL_ORIGIN_OHARA_RPC"
    },
    {
        no: 8,
        name: "TOOL_ORIGIN_COMPOSITE"
    }
]);
/**
 * DisplayHints carries pure-data rendering hints. Function-typed UI
 * concerns (formatSuccess, isValidOutput) stay in TS overrides — they cannot
 * live in proto.
 *
 * @generated from message mono.agenttools.v1.DisplayHints
 */ export class DisplayHints extends Message {
    static fromBinary(bytes, options) {
        return new DisplayHints().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisplayHints().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisplayHints().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisplayHints, a, b);
    }
    constructor(data){
        super(), /**
   * Human-readable name (e.g., "Query CLINs").
   *
   * @generated from field: string display_name = 1;
   */ _define_property(this, "displayName", ""), /**
   * String name of a lucide-react icon (e.g., "ClipboardList"). The frontend
   * resolves this via a Record<string, LucideIcon> registry.
   *
   * @generated from field: string lucide_icon = 2;
   */ _define_property(this, "lucideIcon", ""), /**
   * Gerund-form loading text (e.g., "Querying CLINs…").
   *
   * @generated from field: string loading_text = 3;
   */ _define_property(this, "loadingText", ""), /**
   * Optional empty-state text.
   *
   * @generated from field: string empty_text = 4;
   */ _define_property(this, "emptyText", ""), /**
   * Optional multi-step progress UI hints.
   *
   * @generated from field: repeated mono.agenttools.v1.ProgressStep progress_steps = 5;
   */ _define_property(this, "progressSteps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DisplayHints, "runtime", proto3);
_define_property(DisplayHints, "typeName", "mono.agenttools.v1.DisplayHints");
_define_property(DisplayHints, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lucide_icon",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "loading_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "empty_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "progress_steps",
            kind: "message",
            T: ProgressStep,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agenttools.v1.ProgressStep
 */ export class ProgressStep extends Message {
    static fromBinary(bytes, options) {
        return new ProgressStep().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgressStep().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgressStep().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgressStep, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string loading_text = 3;
   */ _define_property(this, "loadingText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgressStep, "runtime", proto3);
_define_property(ProgressStep, "typeName", "mono.agenttools.v1.ProgressStep");
_define_property(ProgressStep, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "loading_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ToolDescriptor is the canonical representation of an agent tool.
 *
 * @generated from message mono.agenttools.v1.ToolDescriptor
 */ export class ToolDescriptor extends Message {
    static fromBinary(bytes, options) {
        return new ToolDescriptor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ToolDescriptor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ToolDescriptor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ToolDescriptor, a, b);
    }
    constructor(data){
        super(), /**
   * Unique stable id (e.g., "query_clins"). External contract — see Phase 0.5
   * name-stability lockdown.
   *
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * Logical grouping (e.g., "govcon", "onlyoffice", "meta").
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * One-paragraph description; surfaced to the LLM and the user.
   *
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * Short phrases describing when to reach for this tool.
   *
   * @generated from field: repeated string use_cases = 4;
   */ _define_property(this, "useCases", []), /**
   * @generated from field: mono.agenttools.v1.TokenCost token_cost = 5;
   */ _define_property(this, "tokenCost", 0), /**
   * Other tools that this tool implies / pulls into activation together.
   *
   * @generated from field: repeated string dependencies = 6;
   */ _define_property(this, "dependencies", []), /**
   * @generated from field: mono.agenttools.v1.ToolOrigin origin = 7;
   */ _define_property(this, "origin", 0), /**
   * Service name implementing the tool ("shanks", "iceburg", "ryugu", …).
   * String, not enum, to accommodate composite/cross-service tools.
   *
   * @generated from field: string implementing_service = 8;
   */ _define_property(this, "implementingService", ""), /**
   * JSON Schema for the tool's input parameters (function-calling format
   * expected by the LLM). Carried as google.protobuf.Struct — lossless across
   * Go/TS, no schema-of-schema lock-in.
   *
   * @generated from field: google.protobuf.Struct input_schema = 10;
   */ _define_property(this, "inputSchema", void 0), /**
   * Optional output schema.
   *
   * @generated from field: google.protobuf.Struct output_schema = 11;
   */ _define_property(this, "outputSchema", void 0), /**
   * @generated from field: mono.agenttools.v1.DisplayHints display = 20;
   */ _define_property(this, "display", void 0), /**
   * Project types for which this tool should be pre-activated without the
   * LLM needing to discover/request it. Values match shanks ProjectType
   * constants: "capture", "proposal", "contract", "delivery",
   * "vendor_library", "general".
   *
   * @generated from field: repeated string activate_for_project_types = 30;
   */ _define_property(this, "activateForProjectTypes", []), /**
   * If true, pre-activate for all project types (and for no-project chats).
   *
   * @generated from field: bool default_active = 31;
   */ _define_property(this, "defaultActive", false), /**
   * Build provenance for client-side cache busting and debugging.
   *
   * @generated from field: string source_revision = 90;
   */ _define_property(this, "sourceRevision", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ToolDescriptor, "runtime", proto3);
_define_property(ToolDescriptor, "typeName", "mono.agenttools.v1.ToolDescriptor");
_define_property(ToolDescriptor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "use_cases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "token_cost",
            kind: "enum",
            T: proto3.getEnumType(TokenCost)
        },
        {
            no: 6,
            name: "dependencies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "origin",
            kind: "enum",
            T: proto3.getEnumType(ToolOrigin)
        },
        {
            no: 8,
            name: "implementing_service",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "input_schema",
            kind: "message",
            T: Struct
        },
        {
            no: 11,
            name: "output_schema",
            kind: "message",
            T: Struct
        },
        {
            no: 20,
            name: "display",
            kind: "message",
            T: DisplayHints
        },
        {
            no: 30,
            name: "activate_for_project_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 31,
            name: "default_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 90,
            name: "source_revision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agenttools.v1.ListToolsRequest
 */ export class ListToolsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListToolsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListToolsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListToolsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListToolsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Optional filter: only return tools relevant to this project type.
   *
   * @generated from field: string project_type = 1;
   */ _define_property(this, "projectType", ""), /**
   * Optional filter: only return tools in this category.
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * When false (default), input_schema is omitted from each descriptor to
   * keep the list payload small. Use GetTool to fetch a single full schema.
   *
   * @generated from field: bool include_input_schema = 3;
   */ _define_property(this, "includeInputSchema", false), /**
   * When false (default), output_schema is omitted.
   *
   * @generated from field: bool include_output_schema = 4;
   */ _define_property(this, "includeOutputSchema", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListToolsRequest, "runtime", proto3);
_define_property(ListToolsRequest, "typeName", "mono.agenttools.v1.ListToolsRequest");
_define_property(ListToolsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_input_schema",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "include_output_schema",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.agenttools.v1.ListToolsResponse
 */ export class ListToolsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListToolsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListToolsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListToolsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListToolsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agenttools.v1.ToolDescriptor tools = 1;
   */ _define_property(this, "tools", []), /**
   * Opaque hash of the catalog contents; clients cache by this and refetch
   * when it changes.
   *
   * @generated from field: string catalog_version = 2;
   */ _define_property(this, "catalogVersion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListToolsResponse, "runtime", proto3);
_define_property(ListToolsResponse, "typeName", "mono.agenttools.v1.ListToolsResponse");
_define_property(ListToolsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tools",
            kind: "message",
            T: ToolDescriptor,
            repeated: true
        },
        {
            no: 2,
            name: "catalog_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agenttools.v1.GetToolRequest
 */ export class GetToolRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetToolRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetToolRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetToolRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetToolRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetToolRequest, "runtime", proto3);
_define_property(GetToolRequest, "typeName", "mono.agenttools.v1.GetToolRequest");
_define_property(GetToolRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agenttools.v1.GetToolResponse
 */ export class GetToolResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetToolResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetToolResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetToolResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetToolResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agenttools.v1.ToolDescriptor tool = 1;
   */ _define_property(this, "tool", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetToolResponse, "runtime", proto3);
_define_property(GetToolResponse, "typeName", "mono.agenttools.v1.GetToolResponse");
_define_property(GetToolResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tool",
            kind: "message",
            T: ToolDescriptor
        }
    ]));
/**
 * @generated from message mono.agenttools.v1.WatchToolsRequest
 */ export class WatchToolsRequest extends Message {
    static fromBinary(bytes, options) {
        return new WatchToolsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WatchToolsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WatchToolsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WatchToolsRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(WatchToolsRequest, "runtime", proto3);
_define_property(WatchToolsRequest, "typeName", "mono.agenttools.v1.WatchToolsRequest");
_define_property(WatchToolsRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.agenttools.v1.WatchToolsResponse
 */ export class WatchToolsResponse extends Message {
    static fromBinary(bytes, options) {
        return new WatchToolsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WatchToolsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WatchToolsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WatchToolsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from oneof mono.agenttools.v1.WatchToolsResponse.event
   */ _define_property(this, "event", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(WatchToolsResponse, "runtime", proto3);
_define_property(WatchToolsResponse, "typeName", "mono.agenttools.v1.WatchToolsResponse");
_define_property(WatchToolsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "added",
            kind: "message",
            T: ToolDescriptor,
            oneof: "event"
        },
        {
            no: 2,
            name: "updated",
            kind: "message",
            T: ToolDescriptor,
            oneof: "event"
        },
        {
            no: 3,
            name: "removed",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            oneof: "event"
        },
        {
            no: 4,
            name: "snapshot_complete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            oneof: "event"
        }
    ]));
